import { Header } from "@exopengithub/exokit";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useUser } from "src/common/context/userContextUtils.js";
import { useDisplayName } from "src/common/utils/hooks/useDisplayName.js";
import { getFirstName } from "./getFirstName.js";

interface DashboardHeaderProps {
	search?: ReactNode;
	/** Domän/Bolag trail — omitted when there's no company domain in scope
	 * (AllDomainsDashboard), which keeps the old "Welcome back" breadcrumb. */
	breadcrumbs?: { label: string; href: string }[];
}

/** Shared between StartDashboard and AllDomainsDashboard — the greeting doesn't depend on a selected company domain. */
export const DashboardHeader = ({
	search,
	breadcrumbs,
}: DashboardHeaderProps) => {
	const { t } = useTranslation();
	const { user } = useUser();
	const displayName = useDisplayName(user);
	const firstName = getFirstName(displayName);

	return (
		<Header
			breadcrumbs={breadcrumbs ?? [{ label: t("Welcome back") }]}
			title={
				breadcrumbs
					? t("Welcome back {{name}}", { name: firstName })
					: firstName
			}
			search={search}
		/>
	);
};
